(() => {
  'use strict';
  // Product page fixes that run after ASSHCommerce.boot(): never open a product on a
  // colour/size that cannot be bought, mark sold-out colours, and keep the
  // server-rendered SEO (title, description, Product schema) from Shopify.
  const shop=window.ASSHShop;if(!shop?.currentSlug)return;
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const norm=s=>String(s||'').normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase();
  const realName=c=>({'Essential Black':'Negro','Tinto':'Vino','Azul Océano':'Azul Oceano'}[c]||c);
  const visualName=c=>({'Negro':'Essential Black','Vino':'Tinto','Azul Oceano':'Azul Océano'}[c]||c);
  // Read before boot() rewrites the URL with ?variant=.
  const askedForVariant=new URL(location.href).searchParams.has('variant');

  function restoreSeo(){
    const title=$('title[data-assh-seo]'),desc=$('meta[name="description"][data-assh-seo]');
    if(title&&document.title!==title.dataset.asshSeo)document.title=title.dataset.asshSeo;
    if(desc&&desc.content!==desc.dataset.asshSeo)desc.content=desc.dataset.asshSeo;
    if($('#assh-product-ldjson'))document.getElementById('assh-product-schema-v37')?.remove();
  }

  // "Cómo se siente" cards per product (V109 shipped the Strapflex Waist values for every product).
  // Built from each product's own fit copy in the V109 catalog / Shopify description.
  const FIT={
    'strapflex-waist-crop-top':[['SOPORTE','MEDIO','Sujeción para estudio y movimiento diario.'],['AJUSTE','CEÑIDO','Define sin pedirte que dejes de moverte.'],['LARGO','CROP','Banda en cintura para una silueta limpia.']],
    'strapflex-top':[['AJUSTE','CEÑIDO','Define sin pedirte que dejes de moverte.'],['TIRANTES','AJUSTABLES','Personaliza el soporte en estudio.'],['USO','ESTUDIO','Pilates, yoga y cualquier sesión de movimiento.']],
    'crop-top-deportivo':[['SOPORTE','INTEGRADO','Para pilates, yoga y entrenamiento funcional.'],['TIRANTES','AJUSTABLES','Ajusta el soporte a tu cuerpo.'],['LARGO','CROP','Ajuste ceñido y silueta limpia.']],
    'backcut-top':[['SOPORTE','INTEGRADO','Soporte al frente, libertad en la espalda.'],['ESPALDA','ABIERTA','Corte en V que ventila donde más se necesita.'],['AJUSTE','CEÑIDO','Acompaña el movimiento sin estorbar.']],
    'strapflex-cross-strap-top':[['TIRANTES','CRUZADOS','Dan soporte y definen el torso.'],['AJUSTE','CEÑIDO','Sin comprimir.'],['ESTILO','TANK TOP','Para cualquier clase donde el outfit importa.']],
    'flexfit-leggings':[['TIRO','ALTO','Cintura ancha que no se enrolla ni baja.'],['AJUSTE','SEGUNDA PIEL','Se adapta sin comprimir.'],['USO','ESTUDIO','Pilates, yoga y barre.']],
    'flex-motion-leggings':[['TIRO','ALTO','Cintura ancha que no se enrolla.'],['LARGO','CAPRI 3/4','Para yoga, pilates y entrenamiento funcional.'],['AJUSTE','SEGUNDA PIEL','Se adapta sin comprimir.']],
    'flexmove-leggings':[['TIRO','ALTO','Cintura ancha que no baja.'],['LARGO','COMPLETO','Con bolsillo lateral.'],['AJUSTE','SEGUNDA PIEL','Para running, gym y todo lo que sigue.']],
    'sleekstride-leggings':[['TIRO','ALTO','Cintura ancha y estructurada que se adapta al cuerpo.'],['LARGO','COMPLETO','Cortes laterales estratégicos.'],['AJUSTE','SEGUNDA PIEL','Para pilates, yoga o cualquier rutina.']],
    'free-flow-biker':[['TIRO','ALTO','Cintura ancha que no cede.'],['LARGO','MID-THIGH','Con bolsillo lateral.'],['AJUSTE','CEÑIDO','Sin comprimir; para pilates, barre y cardio.']],
    'back-beat-biker':[['TIRO','ALTO','Soporte cómodo dentro y fuera del entrenamiento.'],['AJUSTE','CEÑIDO Y FLEXIBLE','Tacto suave que acompaña el movimiento.'],['INTENSIDAD','MEDIA','Pensado para movimiento de intensidad media.']],
    'falda-assh':[['SHORT','INTEGRADO','Short interior con bolsillo.'],['CINTURA','ELÁSTICA','Banda ancha que se queda en su lugar.'],['LARGO','MINI','Para tenis, running y pickleball.']],
    'activeess-polo':[['CUELLO','POLO','Del gym a la calle sin cambiarte.'],['MANGA','CORTA','Fresca para entrenar y moverte.'],['AJUSTE','REGULAR','Cómodo y sin transparencia.']],
    'swift-hood-jacket':[['MANGA','LARGA','Cobertura ligera para seguir afuera.'],['CAPUCHA','INTEGRADA','Para running, trail y aire libre.'],['CORTE','REGULAR','Corte deportivo para usar en capas.']],
    'breeze-bound-jacket':[['MANGA','LARGA','Del calentamiento al exterior sin cambiar.'],['CAPUCHA','SIN CAPUCHA','Silueta ligera y limpia.'],['CORTE','REGULAR','Corte deportivo para usar en capas.']]
  };
  // "Completa el look" alternatives when a card repeats the product being viewed.
  const LOOK_POOL=['strapflex-waist-crop-top','flexfit-leggings','free-flow-biker','breeze-bound-jacket','crop-top-deportivo','falda-assh'];

  function fixFit(){
    const cards=FIT[shop.currentSlug],articles=$$('.pdp-fit-grid-v32 article');
    if(cards&&articles.length>=3)cards.forEach(([label,value,copy],i)=>{const a=articles[i];$('strong',a).textContent=label;$('b',a).textContent=value;$('p',a).textContent=copy;});
    const fitLine=$('[data-pdp-fit]')?.textContent.replace(/^\s*Ajuste:\s*/i,'').trim(),accordion=$$('.pdp-accordions-v32 details').find(d=>/FIT/i.test($('summary',d)?.textContent||''));
    if(fitLine&&accordion)$('p',accordion).textContent=fitLine;
  }

  // A swapped "Completa el look" card keeps the swatches and arrows of the product it replaced (V109 binds
  // them to it), so they showed the other product's photos. Rebuild them for the new product.
  const fileBase=u=>String(u||'').split('?')[0].split('/').pop().toLowerCase();
  const colourFile=c=>({'Essential Black':'negro','Tinto':'vino'}[c]||norm(c).replace(/[^a-z0-9]+/g,'-'));
  function rewireLook(card,slug,api){
    const colours=window.ASSHCatalogV53?.[slug]?.colors||{},names=Object.keys(colours),img=$('img',card);if(!names.length||!img)return;
    const current=fileBase(img.getAttribute('src'));
    let colour=names.find(c=>colours[c].some(u=>fileBase(u)===current))||names.find(c=>current.includes(colourFile(c)))||names[0];
    let index=Math.max(0,colours[colour].findIndex(u=>fileBase(u)===current));
    const show=()=>{api.setPhoto(img,colours[colour][index]);img.alt=(api.names[slug]||'')+' · '+colour;};
    const box=$('.v54-look-swatches',card);
    if(box){const fresh=box.cloneNode(true);box.replaceWith(fresh);const buttons=$$('[data-v54-color]',fresh);
      for(const b of buttons){b.style.display=names.includes(b.dataset.v54Color)?'':'none';b.classList.toggle('is-active',b.dataset.v54Color===colour);
        b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();colour=b.dataset.v54Color;index=0;show();buttons.forEach(x=>x.classList.toggle('is-active',x===b));});}}
    const nav=$('.v54-look-nav',card);
    if(nav){const fresh=nav.cloneNode(true);nav.replaceWith(fresh);
      $$('button',fresh).forEach(b=>b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();const list=colours[colour];index=(index+(b.classList.contains('v54-look-next')?1:-1)+list.length)%list.length;show();}));}
  }

  function fixLook(api){
    const cards=$$('.pdp-look-card-v43'),shown=cards.map(c=>c.dataset.productSlug);
    const photoOf=slug=>{const img=(api.products[slug]?.featured_image||'').replace(/^\/\//,'https://');return img&&img+(img.includes('?')?'&':'?')+'width=1200';};
    for(const card of cards){
      if(card.dataset.productSlug!==shop.currentSlug)continue;
      const slug=LOOK_POOL.find(s=>s!==shop.currentSlug&&!shown.includes(s)&&api.products[s]),p=api.products[slug];if(!p)continue;
      shown.push(slug);
      const href='/products/'+shop.handles[slug]+'?product='+slug,title=api.names[slug]||p.title,img=photoOf(slug);
      card.dataset.productSlug=slug;card.dataset.productTitle=title;
      $$('a',card).forEach(a=>a.setAttribute('href',href));
      const photo=$('img',card);if(photo&&img){api.setPhoto(photo,img);photo.alt=title;}
      $('h3',card).textContent=title;$('.pdp-look-meta-v43 span',card).textContent=api.money(p.price/100);
      const quick=$('[data-v41-quick]',card);if(quick)quick.dataset.v41Quick=slug;
      rewireLook(card,slug,api);
    }
  }

  function run(){
    const api=window.ASSHCommerce,p=api?.products?.[shop.currentSlug];
    restoreSeo();addEventListener('load',restoreSeo);
    if(!p)return;
    fixFit();fixLook(api);
    const names=(p.options||[]).map(o=>typeof o==='string'?o:o.name);
    const ci=names.findIndex(n=>/color/i.test(n)),si=names.findIndex(n=>/talla|size/i.test(n));
    const colorOf=v=>v?.options?.[ci]||'',sizeOf=v=>v?.options?.[si]||'';
    const markSoldOut=()=>$$('[data-pdp-color]').forEach(button=>{
      const label=button.getAttribute('aria-label'),colour=norm(realName(label));
      const soldOut=!p.variants.some(v=>v.available&&norm(colorOf(v))===colour);
      button.classList.toggle('is-sold-out',soldOut);
      if(soldOut)button.title=label+' · Agotado';else button.removeAttribute('title');
    });
    markSoldOut();
    // Mobile: size right under the colours (V109 already moves the colours under the gallery).
    const sizeOption=$$('.pdp-option-v32').find(x=>$('.pdp-sizes-v32',x));
    if(sizeOption){
      const home=sizeOption.parentNode,next=sizeOption.nextSibling,mq=matchMedia('(max-width:760px)');
      const place=()=>{const colours=$('.pdp-mobile-color-v73');
        if(mq.matches&&colours){colours.after(sizeOption);sizeOption.classList.add('assh-mobile-size-v1');}
        else if(sizeOption.parentNode!==home){home.insertBefore(sizeOption,next);sizeOption.classList.remove('assh-mobile-size-v1');}};
      place();mq.addEventListener('change',place);
    }
    const current=()=>api.resolve(shop.currentSlug,$('[data-pdp-color-name]')?.textContent.trim(),$('.pdp-sizes-v32 button.is-active')?.textContent.trim());
    if(!askedForVariant&&!current()?.available){
      const colour=norm(realName($('[data-pdp-color-name]')?.textContent.trim()));
      const v=p.variants.find(x=>x.available&&norm(colorOf(x))===colour)
        ||p.variants.find(x=>x.available&&String(x.id)===String(shop.selectedVariant))
        ||p.variants.find(x=>x.available);
      if(v){
        $$('[data-pdp-color]').find(b=>b.getAttribute('aria-label')===visualName(colorOf(v)))?.click();
        // Size buttons are re-enabled by syncPdp in a microtask after the colour click.
        setTimeout(()=>$$('.pdp-sizes-v32 button').find(b=>b.textContent.trim()===sizeOf(v))?.click(),0);
      }
    }
    const style=document.createElement('style');
    style.textContent='.pdp-swatches-v32 button.is-sold-out{opacity:.38}';
    document.head.append(style);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

// Size guide inside the product page. The prototype carried its own copy of old measurements
// (S–XL only, with typos); it now shows the official `custom.tabla_tallas` from Shopify, the same
// data as /pages/guia-tallas. The layout prints it as JSON in #assh-size-table.
(() => {
  const src=document.getElementById('assh-size-table');
  let data=null;try{data=JSON.parse(src?.textContent||'null');}catch(e){}
  if(!data||!Array.isArray(data.headers)||!Array.isArray(data.rows))return;
  const esc=s=>String(s??'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const cm=v=>/^\d+(\.\d+)?$/.test(String(v).trim())?v+' cm':v;
  const head=['Medida',...data.headers.slice(1)];
  const html='<thead><tr>'+head.map(h=>'<th>'+esc(h)+'</th>').join('')+'</tr></thead><tbody data-assh-size="1">'
    +data.rows.map(r=>'<tr>'+r.map((c,i)=>i?'<td>'+esc(cm(c))+'</td>':'<th scope="row">'+esc(c)+'</th>').join('')+'</tr>').join('')+'</tbody>';
  const render=()=>{
    const table=document.querySelector('[data-size-guide-table]');
    if(table&&!table.querySelector('[data-assh-size]'))table.innerHTML=html;
    const note=document.querySelector('[data-size-guide-note]');
    if(note)note.textContent='Medidas de la prenda extendida en plano. El contorno es aproximadamente el doble del ancho.';
  };
  const start=()=>{
    render();
    const table=document.querySelector('[data-size-guide-table]');
    if(table)new MutationObserver(render).observe(table,{childList:true});
    document.addEventListener('click',e=>{if(e.target.closest('[data-size-guide-open]'))setTimeout(render,0);});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

// Model note on the product photos: V109's script writes "La modelo usa talla S." for every product. Keep the
// real text the layout printed in data-assh-model (custom.modelo_talla / modelo_estatura_cm); empty stays hidden.
// V109 hides the note up to 900 px; there it goes right under the size buttons, where the size is chosen.
(() => {
  const note=document.querySelector('[data-pdp-model-note][data-assh-model]');if(!note)return;
  const real=note.dataset.asshModel,keep=()=>{if(note.textContent!==real)note.textContent=real;};
  keep();new MutationObserver(keep).observe(note,{childList:true,characterData:true,subtree:true});
  if(!real)return;
  const home=note.parentNode,next=note.nextSibling,mq=matchMedia('(max-width:900px)');
  const place=()=>{const sizes=document.querySelector('.pdp-sizes-v32');
    if(mq.matches&&sizes){sizes.after(note);note.classList.add('assh-model-note-mobile');}
    else if(note.parentNode!==home){home.insertBefore(note,next);note.classList.remove('assh-model-note-mobile');}};
  const style=document.createElement('style');
  style.textContent='@media (max-width:900px){.pdp-gallery-model-note-v35.assh-model-note-mobile{display:block!important;margin:12px 0 0;font-size:11px;line-height:1.4;letter-spacing:.02em;color:#605c56}}';
  document.head.append(style);
  const start=()=>{place();mq.addEventListener('change',place);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
